interface UsageCounterProps {
  rewritesRemaining: number | null;
  // Optional for backward compatibility — callers wire it to their own
  // upgrade flow (e.g. the Editor opens a Stripe checkout session).
  onUpgradeClick?: () => void;
}

/**
 * Shared daily-usage hint. Visually mirrors the Coach's ChatInput hint so
 * both tools look identical: a compact 12px line, muted normally and red
 * once the limit is hit.
 */
export function UsageCounter({
  rewritesRemaining,
  onUpgradeClick,
}: UsageCounterProps) {
  // Pro users have null remaining — nothing to show.
  if (rewritesRemaining === null) {
    return null;
  }

  // Limit reached — show the upgrade CTA.
  if (rewritesRemaining === 0) {
    return (
      <div style={{ fontSize: '12px', color: '#ff7373' }}>
        Daily limit reached ·{' '}
        <button
          onClick={onUpgradeClick}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            fontSize: '12px',
            fontFamily: 'inherit',
            color: 'var(--accent)',
            cursor: 'pointer',
          }}
        >
          Upgrade to Pro
        </button>
      </div>
    );
  }

  // Remaining interactions today — shared daily counter across tools.
  return (
    <div style={{ fontSize: '12px', color: 'var(--text-muted)' }}>
      {`${rewritesRemaining} interaction${rewritesRemaining === 1 ? '' : 's'} remaining today`}
    </div>
  );
}
